import { Component, OnInit } from '@angular/core';
import { VerDocumentoComponent, VerDocumentoTemplate } from '../../../../comum/controls/mat-ver-documento';
import { AngularFirestore } from 'angularfire2/firestore';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'termo-privacidade',
    template: VerDocumentoTemplate ,
})
export class TermoPrivacidadeComponent extends VerDocumentoComponent  {

    ngOnInit(): void {
      this.abrirDocumento('TermoPrivacidade');
    }
  

}
